import { useSEO } from "../lib/useSEO";
import { Reveal } from "../components/Reveal";
import { SectionLabel } from "../components/SectionLabel";
import { RoyalListForm } from "../components/RoyalListForm";

const PERKS = [
  { title: "Royal Vault Drops", text: "First word when something new enters the Vault." },
  { title: "Unreleased Music", text: "Rare recordings and preserved works from the Royal Vault." },
  { title: "Official Release News", text: "Statements, dates and artwork before the world sees them." },
  { title: "Behind the Scenes", text: "Voice notes, sessions, and the moments in between." },
  { title: "Videos & Performances", text: "Announcements straight to your inbox." },
  { title: "Exclusive Creative Content", text: "And whatever else she feels like creating." },
];

export default function RoyalList() {
  useSEO("Join the Royal List", "Unreleased music. New releases. Royal Vault drops. Shows. Stories — straight from the Queen.");

  return (
    <div data-testid="royal-list-portal" className="pt-32 sm:pt-40 pb-20 relative">
      <div className="absolute inset-0 bg-wine/10 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="max-w-3xl">
          <SectionLabel>The Inner Circle</SectionLabel>
          <Reveal>
            <h1 className="font-serif text-5xl sm:text-7xl tracking-tight text-cream" data-testid="royal-list-heading">
              JOIN THE<br /><span className="italic text-goldglow">ROYAL LIST</span>
            </h1>
            <p className="mt-8 text-lg text-cream/85 leading-relaxed">
              This isn't a newsletter. It's a letter from the Queen — personal, occasional, and always worth opening.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {PERKS.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.08}>
              <div className="border border-gold/15 bg-gallery/60 p-7 h-full" data-testid={`perk-${i}`}>
                <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-gold/70">{String(i + 1).padStart(2, "0")}</p>
                <p className="mt-3 font-serif text-xl text-cream">{p.title}</p>
                <p className="mt-2 text-sm text-sand leading-relaxed">{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-16 max-w-2xl mx-auto">
          <div className="border border-gold/25 bg-gallery p-8 sm:p-12">
            <p className="font-serif text-2xl sm:text-3xl text-cream tracking-tight text-center mb-8">
              Straight from the Queen.
            </p>
            <RoyalListForm source="royal-list-page" />
          </div>
        </Reveal>
      </div>
    </div>
  );
}
